import * as i0 from '@angular/core';
import { Injectable, EventEmitter, Component, Input, Output, NgModule } from '@angular/core';
import { first } from 'rxjs/operators';
import * as i4 from 'base-itinerary-of-services-library';
import { BaseItineraryOfServicesLibraryService } from 'base-itinerary-of-services-library';
import * as i1 from 'dirty-check-store';
import * as i2 from '@ngrx/store';
import * as i3 from 'ngx-toastr';
import * as i5 from 'step-status-update-payload-service';
import * as i6 from '@angular/common';
import * as i7 from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import * as i8 from 'primeng/button';
import * as i9 from 'step-status-update-component-library';
import { StepStatusUpdateComponentLibraryModule } from 'step-status-update-component-library';
import * as i10 from 'maximize-dialog-library';
import { MaximizeDialogLibraryModule } from 'maximize-dialog-library';
import * as i11 from 'assigning-task-library';
import { AssigningTaskLibraryModule } from 'assigning-task-library';
import * as i12 from 'primeng/divider';
import * as i13 from 'last-update-library';
import { LastUpdateLibraryModule } from 'last-update-library';
import * as i14 from 'primeng/multiselect';
import * as i15 from 'primeng/inputnumber';
import * as i16 from 'custom-questionnaire';
import { CustomQuestionnaireModule } from 'custom-questionnaire';
import { PrimengLibraryModule } from 'primeng-library';

class ItineraryOfServicesLibraryService {
    constructor() { }
}
ItineraryOfServicesLibraryService.ɵfac = function ItineraryOfServicesLibraryService_Factory(t) { return new (t || ItineraryOfServicesLibraryService)(); };
ItineraryOfServicesLibraryService.ɵprov = i0.ɵɵdefineInjectable({ token: ItineraryOfServicesLibraryService, factory: ItineraryOfServicesLibraryService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ItineraryOfServicesLibraryService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

const _c0 = function (a0) { return { "layoutCode": a0 }; };
function ItineraryOfServicesLibraryComponent_div_5_Template(rf, ctx) { if (rf & 1) {
    const _r13 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 32);
    i0.ɵɵelementStart(1, "ul");
    i0.ɵɵelementStart(2, "li", 33);
    i0.ɵɵelement(3, "lib-step-status-update-component-library", 34);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "li", 35);
    i0.ɵɵelement(5, "lib-maximize-dialog-library", 36);
    i0.ɵɵelementStart(6, "i", 37);
    i0.ɵɵlistener("click", function ItineraryOfServicesLibraryComponent_div_5_Template_i_click_6_listener() { i0.ɵɵrestoreView(_r13); const ctx_r12 = i0.ɵɵnextContext(); return ctx_r12.handleClose(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("visaType", ctx_r0.primaryData.caseType != "I130" ? ctx_r0.primaryData.visatype : ctx_r0.primaryData.caseType)("stepDetails", ctx_r0.stepDetails)("isViewMode", ctx_r0.primaryData["isViewMode"])("isCaseRequest", ctx_r0.primaryData["isCaseRequest"]);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("configData", i0.ɵɵpureFunction1(5, _c0, ctx_r0.primaryData == null ? null : ctx_r0.primaryData.layoutCode));
} }
function ItineraryOfServicesLibraryComponent_div_6_Template(rf, ctx) { if (rf & 1) {
    const _r15 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 11);
    i0.ɵɵelementStart(1, "div", 38);
    i0.ɵɵelementStart(2, "lib-assigning-task-library", 39);
    i0.ɵɵlistener("updateStatus", function ItineraryOfServicesLibraryComponent_div_6_Template_lib_assigning_task_library_updateStatus_2_listener($event) { i0.ɵɵrestoreView(_r15); const ctx_r14 = i0.ɵɵnextContext(); return ctx_r14.updateStepStatus($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("visaType", ctx_r1.primaryData.caseType != "I130" ? ctx_r1.primaryData.visatype : ctx_r1.primaryData.caseType)("stepDetails", ctx_r1.stepDetails)("isViewMode", ctx_r1.primaryData["isViewMode"])("isCaseRequest", ctx_r1.primaryData["isCaseRequest"]);
} }
function ItineraryOfServicesLibraryComponent_p_divider_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "p-divider", 40);
} }
function ItineraryOfServicesLibraryComponent_lib_last_update_library_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "lib-last-update-library", 41);
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵproperty("inputDetails", ctx_r3.stepDetails)("primaryData", ctx_r3.primaryData);
} }
function ItineraryOfServicesLibraryComponent_div_45_span_9_span_2_Template(rf, ctx) { if (rf & 1) {
    const _r29 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span", 50);
    i0.ɵɵtext(1, "... ");
    i0.ɵɵelementStart(2, "span", 51);
    i0.ɵɵlistener("click", function ItineraryOfServicesLibraryComponent_div_45_span_9_span_2_Template_span_click_2_listener() { i0.ɵɵrestoreView(_r29); const i_r17 = i0.ɵɵnextContext(2).index; const ctx_r28 = i0.ɵɵnextContext(); return ctx_r28.jobDutyList[i_r17].isCollapsed = false; });
    i0.ɵɵtext(3, "+ more");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function ItineraryOfServicesLibraryComponent_div_45_span_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 48);
    i0.ɵɵtext(1);
    i0.ɵɵtemplate(2, ItineraryOfServicesLibraryComponent_div_45_span_9_span_2_Template, 4, 0, "span", 49);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const i_r17 = i0.ɵɵnextContext().index;
    const ctx_r18 = i0.ɵɵnextContext();
    i0.ɵɵpropertyInterpolate("id", "checkOverflow" + i_r17);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r18.jobDutyList[i_r17].name, "");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r18.checkOverflowFunc("checkOverflow" + i_r17));
} }
function ItineraryOfServicesLibraryComponent_div_45_span_10_li_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "li");
    i0.ɵɵelementStart(1, "span", 54);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const subDuty_r33 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", subDuty_r33.name, " ");
} }
function ItineraryOfServicesLibraryComponent_div_45_span_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 52);
    i0.ɵɵtext(1);
    i0.ɵɵelementStart(2, "ul");
    i0.ɵɵtemplate(3, ItineraryOfServicesLibraryComponent_div_45_span_10_li_3_Template, 3, 1, "li", 53);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const i_r17 = i0.ɵɵnextContext().index;
    const ctx_r19 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r19.jobDutyList[i_r17].name, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r19.jobDutyList[i_r17].subJobDuty);
} }
function ItineraryOfServicesLibraryComponent_div_45_ng_template_14_small_1_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1, "Required");
    i0.ɵɵelementEnd();
} }
function ItineraryOfServicesLibraryComponent_div_45_ng_template_14_small_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "small", 57);
    i0.ɵɵtemplate(1, ItineraryOfServicesLibraryComponent_div_45_ng_template_14_small_1_span_1_Template, 2, 0, "span", 58);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const group_r16 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", group_r16.get("workDetails").errors["required"]);
} }
function ItineraryOfServicesLibraryComponent_div_45_ng_template_14_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "p-multiSelect", 55);
    i0.ɵɵtemplate(1, ItineraryOfServicesLibraryComponent_div_45_ng_template_14_small_1_Template, 2, 1, "small", 56);
} if (rf & 2) {
    const group_r16 = i0.ɵɵnextContext().$implicit;
    const ctx_r20 = i0.ɵɵnextContext();
    i0.ɵɵproperty("options", ctx_r20.experienceList);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !group_r16.get("workDetails").valid && group_r16.get("workDetails").touched && group_r16.get("workDetails").errors);
} }
function ItineraryOfServicesLibraryComponent_div_45_ng_template_15_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 54);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const i_r17 = i0.ɵɵnextContext().index;
    const ctx_r21 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r21.jobDutyList[i_r17].workDetailsText, " ");
} }
function ItineraryOfServicesLibraryComponent_div_45_ng_template_17_small_1_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1, "Required");
    i0.ɵɵelementEnd();
} }
function ItineraryOfServicesLibraryComponent_div_45_ng_template_17_small_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "small", 57);
    i0.ɵɵtemplate(1, ItineraryOfServicesLibraryComponent_div_45_ng_template_17_small_1_span_1_Template, 2, 0, "span", 58);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const group_r16 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", group_r16.get("educationDetails").errors["required"]);
} }
function ItineraryOfServicesLibraryComponent_div_45_ng_template_17_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "p-multiSelect", 59);
    i0.ɵɵtemplate(1, ItineraryOfServicesLibraryComponent_div_45_ng_template_17_small_1_Template, 2, 1, "small", 56);
} if (rf & 2) {
    const group_r16 = i0.ɵɵnextContext().$implicit;
    const ctx_r22 = i0.ɵɵnextContext();
    i0.ɵɵproperty("options", ctx_r22.educationList);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !group_r16.get("educationDetails").valid && group_r16.get("educationDetails").touched && group_r16.get("educationDetails").errors);
} }
function ItineraryOfServicesLibraryComponent_div_45_ng_template_18_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 54);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const i_r17 = i0.ɵɵnextContext().index;
    const ctx_r23 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r23.jobDutyList[i_r17].educationDetailsText, " ");
} }
function ItineraryOfServicesLibraryComponent_div_45_ng_template_20_small_1_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1, "Required");
    i0.ɵɵelementEnd();
} }
function ItineraryOfServicesLibraryComponent_div_45_ng_template_20_small_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "small", 57);
    i0.ɵɵtemplate(1, ItineraryOfServicesLibraryComponent_div_45_ng_template_20_small_1_span_1_Template, 2, 0, "span", 58);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const group_r16 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", group_r16.get("timeSpent").errors["required"]);
} }
function ItineraryOfServicesLibraryComponent_div_45_ng_template_20_Template(rf, ctx) { if (rf & 1) {
    const _r50 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "p-inputNumber", 60);
    i0.ɵɵlistener("onInput", function ItineraryOfServicesLibraryComponent_div_45_ng_template_20_Template_p_inputNumber_onInput_0_listener($event) { i0.ɵɵrestoreView(_r50); const i_r17 = i0.ɵɵnextContext().index; const ctx_r48 = i0.ɵɵnextContext(); return ctx_r48.setTotal($event.value, i_r17); })("onBlur", function ItineraryOfServicesLibraryComponent_div_45_ng_template_20_Template_p_inputNumber_onBlur_0_listener() { i0.ɵɵrestoreView(_r50); const ctx_r51 = i0.ɵɵnextContext(2); return ctx_r51.setTotalOnBLurOnInput(); })("onFocus", function ItineraryOfServicesLibraryComponent_div_45_ng_template_20_Template_p_inputNumber_onFocus_0_listener() { i0.ɵɵrestoreView(_r50); const ctx_r52 = i0.ɵɵnextContext(2); return ctx_r52.setTotalOnBLurOnInput(); });
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(1, ItineraryOfServicesLibraryComponent_div_45_ng_template_20_small_1_Template, 2, 1, "small", 56);
} if (rf & 2) {
    const group_r16 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("useGrouping", false)("min", 1)("max", 100)("maxlength", 4);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !group_r16.get("timeSpent").valid && group_r16.get("timeSpent").touched && group_r16.get("timeSpent").errors);
} }
function ItineraryOfServicesLibraryComponent_div_45_ng_template_21_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 54);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const group_r16 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", group_r16.get("timeSpent").value ? group_r16.get("timeSpent").value + "%" : "", " ");
} }
const _c1 = function (a0, a1) { return { "pi-check": a0, "pi-pencil": a1 }; };
function ItineraryOfServicesLibraryComponent_div_45_ng_template_23_Template(rf, ctx) { if (rf & 1) {
    const _r57 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span", 61);
    i0.ɵɵlistener("click", function ItineraryOfServicesLibraryComponent_div_45_ng_template_23_Template_span_click_0_listener() { i0.ɵɵrestoreView(_r57); const i_r17 = i0.ɵɵnextContext().index; const ctx_r55 = i0.ɵɵnextContext(); return ctx_r55.onEditDone(i_r17); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const i_r17 = i0.ɵɵnextContext().index;
    const ctx_r26 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(1, _c1, ctx_r26.jobDutyList[i_r17].isEditable, !ctx_r26.jobDutyList[i_r17].isEditable));
} }
const _c2 = function (a0) { return { "ios-border-bottom": a0 }; };
const _c3 = function (a0, a1) { return { "pi-angle-right": a0, "pi-angle-down": a1 }; };
function ItineraryOfServicesLibraryComponent_div_45_Template(rf, ctx) { if (rf & 1) {
    const _r60 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 11);
    i0.ɵɵelementStart(1, "div", 42);
    i0.ɵɵelementStart(2, "div", 43);
    i0.ɵɵelementStart(3, "div", 11);
    i0.ɵɵelementStart(4, "div", 15);
    i0.ɵɵelementStart(5, "div", 11);
    i0.ɵɵelementStart(6, "div", 16);
    i0.ɵɵelementStart(7, "span", 44);
    i0.ɵɵlistener("click", function ItineraryOfServicesLibraryComponent_div_45_Template_span_click_7_listener() { i0.ɵɵrestoreView(_r60); const i_r17 = ctx.index; const ctx_r59 = i0.ɵɵnextContext(); return ctx_r59.jobDutyList[i_r17].isCollapsed = !ctx_r59.jobDutyList[i_r17].isCollapsed; });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "div", 17);
    i0.ɵɵtemplate(9, ItineraryOfServicesLibraryComponent_div_45_span_9_Template, 3, 3, "span", 45);
    i0.ɵɵtemplate(10, ItineraryOfServicesLibraryComponent_div_45_span_10_Template, 4, 2, "span", 46);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "div", 19);
    i0.ɵɵelementStart(12, "div", 11);
    i0.ɵɵelementStart(13, "div", 15);
    i0.ɵɵtemplate(14, ItineraryOfServicesLibraryComponent_div_45_ng_template_14_Template, 2, 2, "ng-template", 47);
    i0.ɵɵtemplate(15, ItineraryOfServicesLibraryComponent_div_45_ng_template_15_Template, 2, 1, "ng-template", 47);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(16, "div", 15);
    i0.ɵɵtemplate(17, ItineraryOfServicesLibraryComponent_div_45_ng_template_17_Template, 2, 2, "ng-template", 47);
    i0.ɵɵtemplate(18, ItineraryOfServicesLibraryComponent_div_45_ng_template_18_Template, 2, 1, "ng-template", 47);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(19, "div", 21);
    i0.ɵɵtemplate(20, ItineraryOfServicesLibraryComponent_div_45_ng_template_20_Template, 2, 5, "ng-template", 47);
    i0.ɵɵtemplate(21, ItineraryOfServicesLibraryComponent_div_45_ng_template_21_Template, 2, 1, "ng-template", 47);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(22, "div", 22);
    i0.ɵɵtemplate(23, ItineraryOfServicesLibraryComponent_div_45_ng_template_23_Template, 1, 4, "ng-template", 47);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const i_r17 = ctx.index;
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("formGroupName", i_r17);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(12, _c2, i_r17 === ctx_r4.jobDutyList.length - 1));
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(14, _c3, ctx_r4.jobDutyList[i_r17].isCollapsed, !ctx_r4.jobDutyList[i_r17].isCollapsed));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r4.jobDutyList[i_r17].isCollapsed);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r4.jobDutyList[i_r17].isCollapsed);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", ctx_r4.jobDutyList[i_r17].isEditable && !ctx_r4.disabledControls);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r4.jobDutyList[i_r17].isEditable || ctx_r4.disabledControls);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r4.jobDutyList[i_r17].isEditable && !ctx_r4.disabledControls);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r4.jobDutyList[i_r17].isEditable || ctx_r4.disabledControls);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r4.jobDutyList[i_r17].isEditable && !ctx_r4.disabledControls);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r4.jobDutyList[i_r17].isEditable || ctx_r4.disabledControls);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", !ctx_r4.disabledControls);
} }
function ItineraryOfServicesLibraryComponent_div_46_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 11);
    i0.ɵɵelementStart(1, "div", 10);
    i0.ɵɵelementStart(2, "div", 11);
    i0.ɵɵelement(3, "div", 15);
    i0.ɵɵelementStart(4, "div", 19);
    i0.ɵɵelementStart(5, "div", 11);
    i0.ɵɵelementStart(6, "div", 62);
    i0.ɵɵelementStart(7, "span", 63);
    i0.ɵɵtext(8, "Total : ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "div", 64);
    i0.ɵɵelementStart(10, "span", 65);
    i0.ɵɵtext(11);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext();
    i0.ɵɵadvance(11);
    i0.ɵɵtextInterpolate1("", ctx_r5.totalValue, "%");
} }
function ItineraryOfServicesLibraryComponent_div_47_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 66);
    i0.ɵɵelementStart(1, "div", 10);
    i0.ɵɵelementStart(2, "div", 67);
    i0.ɵɵelementStart(3, "div", 11);
    i0.ɵɵelementStart(4, "div", 15);
    i0.ɵɵelementStart(5, "span", 68);
    i0.ɵɵelement(6, "span", 69);
    i0.ɵɵtext(7, "The sum of % time to be devoted should be equal to 100.");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "div", 19);
    i0.ɵɵelementStart(9, "div", 11);
    i0.ɵɵelement(10, "div", 19);
    i0.ɵɵelementStart(11, "div", 70);
    i0.ɵɵelement(12, "div", 71);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function ItineraryOfServicesLibraryComponent_div_48_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 66);
    i0.ɵɵelementStart(1, "div", 10);
    i0.ɵɵelementStart(2, "div", 72);
    i0.ɵɵelementStart(3, "span", 52);
    i0.ɵɵtext(4, " No records found ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function ItineraryOfServicesLibraryComponent_lib_custom_questionnaire_49_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "lib-custom-questionnaire", 73);
} if (rf & 2) {
    const ctx_r8 = i0.ɵɵnextContext();
    i0.ɵɵproperty("stepId", ctx_r8.primaryData.stepId)("taskId", ctx_r8.primaryData.taskId)("viewQuestions", false)("showSaveBtn", false)("loadedIn", ctx_r8.stepDetails.stepName)("isSection", false);
} }
function ItineraryOfServicesLibraryComponent_p_divider_50_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "p-divider", 74);
} }
function ItineraryOfServicesLibraryComponent_div_54_Template(rf, ctx) { if (rf & 1) {
    const _r62 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 28);
    i0.ɵɵelementStart(1, "button", 75);
    i0.ɵɵlistener("click", function ItineraryOfServicesLibraryComponent_div_54_Template_button_click_1_listener() { i0.ɵɵrestoreView(_r62); const ctx_r61 = i0.ɵɵnextContext(); return ctx_r61.handleCancel(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r10 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("disabled", ctx_r10.disabledControls);
} }
function ItineraryOfServicesLibraryComponent_div_56_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 76);
    i0.ɵɵelement(1, "lib-step-status-update-component-library", 77);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r11 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("visaType", ctx_r11.primaryData.caseType != "I130" ? ctx_r11.primaryData.visatype : ctx_r11.primaryData.caseType)("stepDetails", ctx_r11.stepDetails)("type", ctx_r11.typeOfButton)("showPreviousStepBtn", ctx_r11.showPrev)("showNextStepBtn", ctx_r11.showNext);
} }
class ItineraryOfServicesLibraryComponent extends BaseItineraryOfServicesLibraryService {
    constructor(guard, store, toastService, apiItineraryOfServicesLibraryService, stepStatusUpdatePayloadService) {
        super(guard, store, toastService, apiItineraryOfServicesLibraryService, stepStatusUpdatePayloadService);
        this.guard = guard;
        this.store = store;
        this.toastService = toastService;
        this.apiItineraryOfServicesLibraryService = apiItineraryOfServicesLibraryService;
        this.stepStatusUpdatePayloadService = stepStatusUpdatePayloadService;
        this.dialogClose = new EventEmitter();
        this.showNext = false;
        this.showPrev = false;
    }
    ngOnInit() {
        var _a, _b;
        super.loadInit();
        this.showNext = (_a = this.primaryData) === null || _a === void 0 ? void 0 : _a.showNext;
        this.showPrev = (_b = this.primaryData) === null || _b === void 0 ? void 0 : _b.showPrev;
    }
    checkOverflowFunc(checkOverflowElementId) {
        const element = document.getElementById(checkOverflowElementId);
        return element.clientHeight < element.scrollHeight;
    }
    handleClose() {
        this.guard.canDeactivate().pipe(first()).subscribe((response) => {
            if (response) {
                this.dialogClose.emit();
            }
            else {
                return false;
            }
        });
    }
}
ItineraryOfServicesLibraryComponent.ɵfac = function ItineraryOfServicesLibraryComponent_Factory(t) { return new (t || ItineraryOfServicesLibraryComponent)(i0.ɵɵdirectiveInject(i1.DirtyFormGuard), i0.ɵɵdirectiveInject(i2.Store), i0.ɵɵdirectiveInject(i3.ToastrService), i0.ɵɵdirectiveInject(i4.ApiItineraryOfServicesLibraryService), i0.ɵɵdirectiveInject(i5.StepStatusUpdatePayloadService)); };
ItineraryOfServicesLibraryComponent.ɵcmp = i0.ɵɵdefineComponent({ type: ItineraryOfServicesLibraryComponent, selectors: [["lib-itinerary-of-services-library"]], inputs: { primaryData: "primaryData", isWizard: "isWizard" }, outputs: { dialogClose: "dialogClose" }, features: [i0.ɵɵInheritDefinitionFeature], decls: 57, vars: 17, consts: [[1, "container-fuild"], [1, "row", "pt-4", "d-flex", "align-items-center"], [1, "col-md-8", "step-title"], [1, "mb-0"], ["class", "col-md-4 editBtn headerSubPortion px-0", 4, "ngIf"], ["class", "row", 4, "ngIf"], ["class", "header-divider", 4, "ngIf"], ["sectionCode", "IOS", 3, "inputDetails", "primaryData", 4, "ngIf"], [1, "p-form", 3, "formGroup", "ngSubmit"], [3, "ngClass"], [1, "col-12"], [1, "row"], [1, "blue-sub-header"], ["formArrayName", "jobDutyList"], [1, "ios-table-header"], [1, "col-4"], [1, "col-3"], [1, "col-9", "px-0", "ml-n3"], [1, "ios-title"], [1, "col-8"], [1, "ios-title", "required"], [1, "col-2", "px-0"], [1, "col-2"], ["class", "row", 4, "ngFor", "ngForOf"], ["class", "row mb-3", 4, "ngIf"], [3, "stepId", "taskId", "viewQuestions", "showSaveBtn", "loadedIn", "isSection", 4, "ngIf"], ["type", "dashed", "class", "d-block", 4, "ngIf"], [1, "row", "pb-3"], [1, "col-md-2"], ["pButton", "", "type", "submit", "label", "Save", 1, "save-btn", 3, "ngClass", "disabled"], ["class", "col-md-2", 4, "ngIf"], ["class", "col-md-6 completeStep", 4, "ngIf"], [1, "col-md-4", "editBtn", "headerSubPortion", "px-0"], [1, "col-auto", "px-0", "firstPortion"], ["type", "EDIT", 1, "float-right", 3, "visaType", "stepDetails", "isViewMode", "isCaseRequest"], [1, "col-auto", "pr-0", "pl-2", "secondPortion"], [3, "configData"], [1, "close-icon", "pi", "pi-times", "pull-right", 3, "click"], [1, "col-md-12", "p-0"], [3, "visaType", "stepDetails", "isViewMode", "isCaseRequest", "updateStatus"], [1, "header-divider"], ["sectionCode", "IOS", 3, "inputDetails", "primaryData"], [1, "col-12", 3, "formGroupName"], [1, "ios-table-body", 3, "ngClass"], [1, "ios-row-expand", "pi", 3, "ngClass", "click"], ["class", "ios-regular fixed-height", 3, "id", 4, "ngIf"], ["class", "ios-regular", 4, "ngIf"], [3, "ngIf"], [1, "ios-regular", "fixed-height", 3, "id"], ["class", "ios-absolute-click", 4, "ngIf"], [1, "ios-absolute-click"], [1, "more-text", 3, "click"], [1, "ios-regular"], [4, "ngFor", "ngForOf"], [1, "ios-text"], ["appendTo", "body", "styleClass", "w-100", "formControlName", "workDetails", "defaultLabel", "Select", "optionLabel", "text", "optionValue", "value", "selectedItemsLabel", "{0} items selected", 3, "options"], ["class", "p-error", 4, "ngIf"], [1, "p-error"], [4, "ngIf"], ["appendTo", "body", "styleClass", "w-100", "formControlName", "educationDetails", "defaultLabel", "Select", "optionLabel", "text", "optionValue", "value", "selectedItemsLabel", "{0} items selected", 3, "options"], ["formControlName", "timeSpent", "suffix", "%", "placeholder", "Enter", 3, "useGrouping", "min", "max", "maxlength", "onInput", "onBlur", "onFocus"], [1, "ios-row-edit", "pi", 3, "ngClass", "click"], [1, "col-8", "py-3"], [1, "ios-regular", "total-label", "pull-right"], [1, "col-4", "px-0", "py-3"], [1, "total-value"], [1, "row", "mb-3"], [1, "ios-info-text-holder"], [1, "ios-regular", "no-wrap-ios"], [1, "ios-info-icon", "pi", "pi-info-circle"], [1, "col-4", "px-0"], [1, "arrow-up"], [1, "ios-table-body", "ios-border-bottom", "text-center"], [3, "stepId", "taskId", "viewQuestions", "showSaveBtn", "loadedIn", "isSection"], ["type", "dashed", 1, "d-block"], ["pButton", "", "type", "button", "label", "Cancel", 1, "p-button-secondary", "cancel-btn", "button-width-icon-left", "d-flex", "alogn-items-center", 3, "disabled", "click"], [1, "col-md-6", "completeStep"], [1, "d-flex", "col-12", "justify-content-end", 3, "visaType", "stepDetails", "type", "showPreviousStepBtn", "showNextStepBtn"]], template: function ItineraryOfServicesLibraryComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵelementStart(2, "div", 2);
        i0.ɵɵelementStart(3, "h5", 3);
        i0.ɵɵtext(4, "Provide Itinerary of Services Detail");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(5, ItineraryOfServicesLibraryComponent_div_5_Template, 7, 7, "div", 4);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(6, ItineraryOfServicesLibraryComponent_div_6_Template, 3, 4, "div", 5);
        i0.ɵɵtemplate(7, ItineraryOfServicesLibraryComponent_p_divider_7_Template, 1, 0, "p-divider", 6);
        i0.ɵɵtemplate(8, ItineraryOfServicesLibraryComponent_lib_last_update_library_8_Template, 1, 2, "lib-last-update-library", 7);
        i0.ɵɵelementStart(9, "form", 8);
        i0.ɵɵlistener("ngSubmit", function ItineraryOfServicesLibraryComponent_Template_form_ngSubmit_9_listener() { return ctx.onSubmit(); });
        i0.ɵɵelementStart(10, "div", 9);
        i0.ɵɵelementStart(11, "div", 10);
        i0.ɵɵelementStart(12, "div", 11);
        i0.ɵɵelementStart(13, "div", 10);
        i0.ɵɵelementStart(14, "p", 9);
        i0.ɵɵtext(15, "Below mentioned are the Itinerary of services with the details of Beneficiary's proposed duties and responsibilities. Identify the Percentage of time devoted to each duty and the educational requirement.");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(16, "div", 11);
        i0.ɵɵelementStart(17, "div", 10);
        i0.ɵɵelementStart(18, "h6", 12);
        i0.ɵɵtext(19, "Add Itinerary of Services");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(20, "div", 13);
        i0.ɵɵelementStart(21, "div", 11);
        i0.ɵɵelementStart(22, "div", 10);
        i0.ɵɵelementStart(23, "div", 14);
        i0.ɵɵelementStart(24, "div", 11);
        i0.ɵɵelementStart(25, "div", 15);
        i0.ɵɵelementStart(26, "div", 11);
        i0.ɵɵelement(27, "div", 16);
        i0.ɵɵelementStart(28, "div", 17);
        i0.ɵɵelementStart(29, "span", 18);
        i0.ɵɵtext(30, "List of Duties");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(31, "div", 19);
        i0.ɵɵelementStart(32, "div", 11);
        i0.ɵɵelementStart(33, "div", 15);
        i0.ɵɵelementStart(34, "span", 20);
        i0.ɵɵtext(35, "Work Experience");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(36, "div", 15);
        i0.ɵɵelementStart(37, "span", 20);
        i0.ɵɵtext(38, "Education Needed");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(39, "div", 21);
        i0.ɵɵelementStart(40, "span", 20);
        i0.ɵɵtext(41, "% Time devoted");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(42, "div", 22);
        i0.ɵɵelementStart(43, "span", 18);
        i0.ɵɵtext(44, "Action");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(45, ItineraryOfServicesLibraryComponent_div_45_Template, 24, 17, "div", 23);
        i0.ɵɵtemplate(46, ItineraryOfServicesLibraryComponent_div_46_Template, 12, 1, "div", 5);
        i0.ɵɵtemplate(47, ItineraryOfServicesLibraryComponent_div_47_Template, 13, 0, "div", 24);
        i0.ɵɵtemplate(48, ItineraryOfServicesLibraryComponent_div_48_Template, 5, 0, "div", 24);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(49, ItineraryOfServicesLibraryComponent_lib_custom_questionnaire_49_Template, 1, 6, "lib-custom-questionnaire", 25);
        i0.ɵɵtemplate(50, ItineraryOfServicesLibraryComponent_p_divider_50_Template, 1, 0, "p-divider", 26);
        i0.ɵɵelementStart(51, "div", 27);
        i0.ɵɵelementStart(52, "div", 28);
        i0.ɵɵelement(53, "button", 29);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(54, ItineraryOfServicesLibraryComponent_div_54_Template, 2, 1, "div", 30);
        i0.ɵɵelement(55, "div", 28);
        i0.ɵɵtemplate(56, ItineraryOfServicesLibraryComponent_div_56_Template, 2, 5, "div", 31);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(5);
        i0.ɵɵproperty("ngIf", !ctx.isWizard);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.isWizard);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.isWizard);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.isWizard);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("formGroup", ctx.itineraryOfServicesForm);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngClass", ctx.isWizard ? "row mt-0" : "row main-body mt-2 footer-adjust-v1");
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("ngClass", ctx.isWizard ? "itinerary-of-services-desc mt-0" : "itinerary-of-services-desc");
        i0.ɵɵadvance(31);
        i0.ɵɵproperty("ngForOf", ctx.jobDutyListFormArray);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.jobDutyListFormArray && ctx.jobDutyListFormArray.length > 0);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.jobDutyListFormArray && ctx.jobDutyListFormArray.length > 0);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.jobDutyListFormArray || ctx.jobDutyListFormArray && ctx.jobDutyListFormArray.length === 0);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.isWizard);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.isWizard);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngClass", ctx.itineraryOfServicesForm.invalid || ctx.disabledControls ? "btn-success button-width-icon-left mr-3 btn-success_disabled" : "btn-success button-width-icon-left mr-3")("disabled", ctx.itineraryOfServicesForm.invalid || ctx.disabledControls);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.isWizard);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", !ctx.isWizard);
    } }, directives: [i6.NgIf, i7.ɵangular_packages_forms_forms_ba, i7.NgControlStatusGroup, i7.FormGroupDirective, i6.NgClass, i7.FormArrayName, i6.NgForOf, i8.ButtonDirective, i9.StepStatusUpdateComponentLibraryComponent, i10.MaximizeDialogLibraryComponent, i11.AssigningTaskLibraryComponent, i12.Divider, i13.LastUpdateLibraryComponent, i7.FormGroupName, i14.MultiSelect, i7.NgControlStatus, i7.FormControlName, i15.InputNumber, i7.MaxLengthValidator, i16.CustomQuestionnaireComponent], styles: [".row[_ngcontent-%COMP%]{margin-left:-15px;margin-right:-15px}.save-btn[_ngcontent-%COMP%]{background-color:#19a0da;padding:0 30px!important;font-size:14px!important;border-radius:8px!important}.cancel-btn[_ngcontent-%COMP%]{border-radius:10px;text-transform:uppercase;font-size:12px;font-weight:700;padding:10px}.cancel-btn[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{font-size:20px;padding:2px}.close-icon[_ngcontent-%COMP%]{color:#fff;background-color:#000;padding:8px;border-radius:20px;font-weight:700;cursor:pointer}.step-title[_ngcontent-%COMP%]   h5[_ngcontent-%COMP%]{font:normal normal 700 22px/32px Source Sans Pro;color:#3d3d63}.step-title[_ngcontent-%COMP%]   p[_ngcontent-%COMP%]{font:normal normal normal 16px/22px Source Sans Pro;color:#626262}.itinerary-of-services-desc[_ngcontent-%COMP%]{line-height:22px;margin:15px 0;font:normal normal 600 18px/29px Source Sans Pro;color:#626262}.duty-holder[_ngcontent-%COMP%]{padding:15px 10px 15px 5px;border:solid #979797;border-width:1px 1px 0}.duty-holder.add-border-bottom[_ngcontent-%COMP%]{border-width:1px}.duty-holder[_ngcontent-%COMP%]   .duty-slno[_ngcontent-%COMP%]{background-color:#b5d8ff;height:24px;min-width:24px;border-radius:50%;text-align:center;line-height:24px;margin-right:5px;max-width:24px}.duty-holder[_ngcontent-%COMP%]   .duty-body[_ngcontent-%COMP%]{flex-grow:1}.duty-holder[_ngcontent-%COMP%]   .duty-body[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]{padding-left:20px;margin-bottom:0}.form-error[_ngcontent-%COMP%]{white-space:nowrap;margin-top:-2px;display:block;margin-bottom:-17px}.blue-sub-header[_ngcontent-%COMP%]{line-height:28px;font:normal normal 600 20px/28px Source Sans Pro;color:#0a7bb8}.ios-table-header[_ngcontent-%COMP%]{background-color:#efefef;padding:12px 0 13px;border:solid #707070;border-width:1px 1px 0;white-space:nowrap}.ios-table-header[_ngcontent-%COMP%]   .ios-title[_ngcontent-%COMP%]{font:normal normal 300 14px/20px Source Sans Pro;color:#4a4a4a}.ios-row-expand[_ngcontent-%COMP%]{color:#222b45;background-color:transparent;height:25px;width:25px;text-align:center;line-height:25px;border-radius:50%;display:block;margin:0 auto;font-size:17px;cursor:pointer}.ios-row-expand[_ngcontent-%COMP%]:hover{background-color:#e9ecef}.ios-row-edit[_ngcontent-%COMP%]{color:#19a0da;background-color:transparent;height:25px;width:25px;text-align:center;line-height:25px;border-radius:50%;display:block;margin:8px auto 0;font-size:18px;cursor:pointer}.ios-table-body[_ngcontent-%COMP%]{padding:12px 0 13px;border-color:#707070;border-style:solid;border-width:0 1px}.ios-table-body.ios-border-bottom[_ngcontent-%COMP%]{border-width:0 1px 1px}.ios-regular[_ngcontent-%COMP%]{display:block;position:relative}.ios-regular[_ngcontent-%COMP%], .ios-regular.total-label[_ngcontent-%COMP%]{font:normal normal normal 16px/22px Source Sans Pro;color:#4a4a4a}.ios-regular.total-label[_ngcontent-%COMP%]{line-height:37px}.ios-regular.fixed-height[_ngcontent-%COMP%]{height:44px;overflow:hidden;word-break:break-all}.ios-regular[_ngcontent-%COMP%]   .ios-absolute-click[_ngcontent-%COMP%]{position:absolute;z-index:1;bottom:0;right:0;background:#fff;display:block;padding-right:15px}.ios-regular[_ngcontent-%COMP%]   .ios-absolute-click[_ngcontent-%COMP%]   .more-text[_ngcontent-%COMP%]{color:#19a0da;cursor:pointer}.ios-regular[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]{margin-bottom:0;list-style:none;padding:0;margin-top:10px}.ios-regular[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]:before{content:\"- \"}.ios-text[_ngcontent-%COMP%]{font-size:14px;line-height:18px}.total-value[_ngcontent-%COMP%]{font:normal normal 600 26px/37px Source Sans Pro;color:#4a4a4a}.ios-info-text-holder[_ngcontent-%COMP%]{padding:15px 0;background-color:#efefef;white-space:nowrap;font:normal normal normal 16px/22px Source Sans Pro;color:#4a4a4a}.ios-info-icon[_ngcontent-%COMP%]{margin:0 10px 0 15px;line-height:22px;float:left}.arrow-up[_ngcontent-%COMP%]{width:0;height:0;border-left:7px solid transparent;border-right:7px solid transparent;border-bottom:14px solid #efefef;position:absolute;top:calc(-1rem - 11px);left:9px}.p-multiselect[_ngcontent-%COMP%]{border-radius:7px!important}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ItineraryOfServicesLibraryComponent, [{
        type: Component,
        args: [{
                selector: 'lib-itinerary-of-services-library',
                templateUrl: './itinerary-of-services-library.component.html',
                styleUrls: ['./itinerary-of-services-library.component.scss']
            }]
    }], function () { return [{ type: i1.DirtyFormGuard }, { type: i2.Store }, { type: i3.ToastrService }, { type: i4.ApiItineraryOfServicesLibraryService }, { type: i5.StepStatusUpdatePayloadService }]; }, { primaryData: [{
            type: Input
        }], dialogClose: [{
            type: Output
        }], isWizard: [{
            type: Input
        }] }); })();

class ItineraryOfServicesLibraryModule {
}
ItineraryOfServicesLibraryModule.ɵfac = function ItineraryOfServicesLibraryModule_Factory(t) { return new (t || ItineraryOfServicesLibraryModule)(); };
ItineraryOfServicesLibraryModule.ɵmod = i0.ɵɵdefineNgModule({ type: ItineraryOfServicesLibraryModule });
ItineraryOfServicesLibraryModule.ɵinj = i0.ɵɵdefineInjector({ imports: [[
            StepStatusUpdateComponentLibraryModule,
            PrimengLibraryModule,
            ReactiveFormsModule,
            LastUpdateLibraryModule,
            AssigningTaskLibraryModule,
            MaximizeDialogLibraryModule,
            CustomQuestionnaireModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(ItineraryOfServicesLibraryModule, { declarations: [ItineraryOfServicesLibraryComponent], imports: [StepStatusUpdateComponentLibraryModule,
        PrimengLibraryModule,
        ReactiveFormsModule,
        LastUpdateLibraryModule,
        AssigningTaskLibraryModule,
        MaximizeDialogLibraryModule,
        CustomQuestionnaireModule], exports: [ItineraryOfServicesLibraryComponent] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ItineraryOfServicesLibraryModule, [{
        type: NgModule,
        args: [{
                declarations: [ItineraryOfServicesLibraryComponent],
                imports: [
                    StepStatusUpdateComponentLibraryModule,
                    PrimengLibraryModule,
                    ReactiveFormsModule,
                    LastUpdateLibraryModule,
                    AssigningTaskLibraryModule,
                    MaximizeDialogLibraryModule,
                    CustomQuestionnaireModule
                ],
                exports: [ItineraryOfServicesLibraryComponent]
            }]
    }], null, null); })();

/*
 * Public API Surface of itinerary-of-services-library
 */

/**
 * Generated bundle index. Do not edit.
 */

export { ItineraryOfServicesLibraryComponent, ItineraryOfServicesLibraryModule, ItineraryOfServicesLibraryService };
//# sourceMappingURL=itinerary-of-services-library.js.map
